<template>
	<div>
		<b-modal ref="modal"	no-close-on-backdrop hide-header header-class="border-bottom-0" size="md">
			<!-- form  -->
			<div class="row">
				<div class="col-md-12">
					<h5 class="text-primary">
						<i class="fas fa-list" /> Dados da Categoria 
					</h5>
				</div>
			</div>
			<br />

			<!-- <div class="row">
            <div class="col-md-12">
                <select-input :alias="form.parent_id.alias" :options="form.parent_id.options" v-model="form.parent_id.value" />
            </div>
      </div>-->
			<div class="row">
				<div class="col-md-12">
					<text-input
						:alias="form.description.alias"
						v-model="form.description.value"
					/>
				</div>
			</div>
			<!-- <div class="row">
            <div class="col-md-12">
                <number-input :currencySymbol="' %'" :alias="form.max_discount.alias" v-model="form.max_discount.value" />
            </div>
      </div>-->
			<div class="row">
				<div class="col-md-3">
					<b-form-checkbox
						switch
						inline
						style="margin-right:10px"
						:value="1"
						:unchecked-value="0"
						v-model="form.status.value"
						>Ativo</b-form-checkbox
					>
				</div>
			</div>
			<error-handler :error="error" />

			<b-alert
				:show="alertData.isVisible"
				fade
				variant="danger"
				@dismissed="alertData.isVisible = false"
				dismissible
				>{{ alertData.message }}</b-alert
			>

			<div slot="modal-footer">
				<button
					role="button"
					class="btn btn-outline-secondary"
					@click="$refs.modal.hide()"
				>
					<i class="fas fa-times"></i> Cancelar
				</button>
				<button
					role="button"
					class="btn btn-success"
					style="margin-left:5px"
					@click="store"
				>
					<i class="fas fa-check"></i> Salvar
				</button>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import Form from "../../../mixins/Form";
	export default {
		companents: {
			Form
		},

		data: function () {
			return {
				form: new Form({
					id: {
						default: null
					},

					parent_id: {
						alias: "Essa categoria pertence",
						options: {}
					},

					description: {
						alias: "Descrição",
						validate: {
							required: true
						}
					},

					max_discount: {
						alias: "Desconto Máximo",
						value: null
					},

					status: {
						alias: "Status",
						default: 1
					}
				}),

				error: null,

				alertData: {
					isVisible: false,
					message: null
				}
			};
		},

		computed: {
			category() {
				return this.$store.state.category.category;
			},
		},

		methods: {
			open(id) {
				this.resetForm();
				this.id;
				if (id) {
					this.select(id);
					this.form.id.value = id;
					return;
				}
				this.$refs.modal.show();
				// this.select();
			},

			select(id) {

				this.$store.dispatch("category/getCategory", id)

					.then(response => {
						this.form.setValues(this.category);
						this.$refs.modal.show();

						this.$store.commit("pageHasLoaded");
					})
					.catch(error => {
						this.error = error;
						this.$store.commit("pageHasLoadedWithError", {
							error: error
						});
					});
			},

			getAccountsOptions(data) {
				var options = {};

				for (let index in data) {
					options[data[index].id] = data[index].description;
				}

				return options;
			},

			store() {
				if (this.form.isValid()) {

					this.$store.dispatch("category/storeCategory", this.form.getValues())
						.then(response => {
							this.$emit("stored");

							this.$refs.modal.hide();

							this.$store.commit("hideLoading");

							this.$store.commit("pageHasLoaded");
						})
						.catch(error => {
							this.error = error;
							this.$store.commit("pageHasLoadedWithError", {
								error: error
							});
						});

				} else {
					this.alertData.message = this.form.getFirstErrorMsg();

					this.alertData.isVisible = true;
				}
			},

			resetForm() {
				this.error = null;

				this.alertData.isVisible = false;

				this.form.reset();
			},

		}
	};
</script>

<style>
</style>
